import script from "./PRStockTransferList.vue?vue&type=script&setup=true&lang=js"
export * from "./PRStockTransferList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__